import type { Tenant } from './database.types';

/**
 * Theming data-driven (US-403) : la palette vient du tenant (Supabase),
 * plus jamais codée en dur (audit dette D5/D3).
 * On expose des variables CSS que Tailwind consomme (cf. tailwind.config.js : brand.*).
 */

export interface BrandTheme {
  primary: string;
  dark: string;
  light: string;
}

/** Palette neutre de secours si le tenant n'a pas (encore) de couleurs. */
export const DEFAULT_THEME: BrandTheme = {
  primary: '#E65100',
  dark: '#2C1810',
  light: '#FFF3E0',
};

/**
 * Déduit la palette d'un tenant (logique pure, testable).
 * Tolère les colonnes legacy : primary_color / brand_color / secondary_color.
 */
export function themeFromTenant(tenant: Tenant | null): BrandTheme {
  if (!tenant) return DEFAULT_THEME;
  const primary = tenant.primary_color || tenant.brand_color || DEFAULT_THEME.primary;
  return {
    primary,
    dark: tenant.secondary_color || DEFAULT_THEME.dark,
    // `light` = teinte douce DÉRIVÉE de la couleur primaire (parité legacy `brand_light`).
    // Avant : orange fixe `#FFF3E0`, qui jurait sur les marques foncées (ex. Atlas Royal) —
    // les états sélectionnés / badges affichaient un fond orange « défaillant ».
    // color-mix est déjà utilisé ailleurs (MenuView) → support OK.
    light: `color-mix(in srgb, ${primary} 9%, white)`,
  };
}

/**
 * Applique la palette au document via variables CSS.
 * (Effet de bord isolé ici : testé via le DOM, le reste de la logique reste pure.)
 */
export function applyTheme(theme: BrandTheme, root: HTMLElement = document.documentElement): void {
  root.style.setProperty('--brand-primary', theme.primary);
  root.style.setProperty('--brand-dark', theme.dark);
  root.style.setProperty('--brand-light', theme.light);
}
